import {Injectable} from "@angular/core";
import {environment} from "../../environments/environment";
declare var $: any;
@Injectable()
export class NotificationService {

    env = environment;

    constructor(){}

    /**
     * send a gobal notification setting all params
     * @param {string} color
     * @param {string} text
     */
    public showNotification(color: string, text: string){
        $.notify({
            icon: "notifications",
            message: text

        },{
            type: color,
            timer: this.env.notification_setting.timer,
            placement: {
                from: this.env.notification_setting.from,
                align: this.env.notification_setting.align
            }
        });
    }

    /**
     * send a seccuess format notification
     * @param text
     */
    sendSuccess(text){
        this.showNotification('success' , text)
    }

    /**
     * send a warning format notification
     * @param text
     */
    sendWaning(text){
        this.showNotification('warning' , text)
    }

    /**
     * send a info format notification
     * @param text
     */
    sendInfo(text){
        this.showNotification('info' , text)
    }

    /**
     * send a error format notification
     * @param text
     */
    sendError(text){
        this.showNotification('danger' , text)
    }
}


// WEBPACK FOOTER //
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/services/notification.service.ts